import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

import { JwtService } from './auth/jwt.service';

import { environment } from '../../environments/environment';

@Injectable()
export class ApiService {
  private readonly apiUrl = environment.apiUrl;

  constructor(private http: HttpClient, private jwtService: JwtService) {}

  get(path: string, params: HttpParams = new HttpParams()): Observable<any> {
    return this.http
      .get(`${this.apiUrl}${path}`, {
        headers: this.setHeaders(),
        params,
      })
      .pipe(catchError(this.handleError));
  }

  put(path: string, body: any = {}): Observable<any> {
    return this.http
      .put(`${this.apiUrl}${path}`, JSON.stringify(body), {
        headers: this.setHeaders(),
      })
      .pipe(catchError(this.handleError));
  }

  post(path: string, body: any = {}): Observable<any> {
    return this.http
      .post(`${this.apiUrl}${path}`, JSON.stringify(body), {
        headers: this.setHeaders(),
      })
      .pipe(catchError(this.handleError));
  }

  delete(path: string, body: any = {}): Observable<any> {
    return this.http
      .request('delete', `${this.apiUrl}${path}`, {
        body: JSON.stringify(body),
        headers: this.setHeaders(),
      })
      .pipe(catchError(this.handleError));
  }

  // Fetch Token from either JWT service for Admin/SuperAdmin
  fetchToken() {
    // fetch the token for super admin
    if (this.jwtService.getToken()) {
      return this.jwtService.getToken();
    }
  }

  private setHeaders(): HttpHeaders {
    const token = this.fetchToken();

    if (token) {
      return new HttpHeaders()
        .set('Content-Type', 'application/json')
        .set('Authorization', `Bearer ${token}`);
    }

    return new HttpHeaders().set('Content-Type', 'application/json');
  }

  private handleError(error: any) {
    return throwError(error);
  }
}
